import crudActions from '../crud/actions'
import crudReducers from '../crud/reducers'
import crudSagas from '../crud/sagas'
import {initialDataState} from '../../reducersHelper'
import Api from '../../../api'

const actions = crudActions('PROVIDERSERVICESLOCATIONS_LOCATIONS_CRUD_')
const reducers = crudReducers(actions, 'location', initialDataState)
function * sagas () {
  yield crudSagas(
    actions,
    Api.Crud,
    'providers/:providerId/services/:serviceId/locations',
    'id'
  )
}

export { actions, reducers, sagas }
